var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDriver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9BA0B1",
    fillRule: "evenodd",
    d: "M8.5 4V.997c0-.55.444-.997 1-.997h3c.552 0 1 .447 1 .997V4H20c1.104 0 2 .895 2 2.002v11.996C22 19.104 21.103 20 20 20H2c-1.104 0-2-.895-2-2.002V6.002C0 4.896.897 4 2 4h6.5zM2 6v12h18V6h-6.5v1.003c0 .55-.444.997-1 .997h-3c-.552 0-1-.447-1-.997V6H2zm3 5c0-1.105.895-2 2-2s2 .895 2 2c0 .621-.283 1.492-.727 2.136l1.278.64c.248.123.449.446.449.729V15c0 .552-.451 1-1.004 1H5.004C4.45 16 4 15.556 4 15v-.495c0-.279.197-.603.443-.726l1.285-.642C5.283 12.493 5 11.62 5 11zm5.5-9v4h1V2h-1zm.5 9c0-.552.449-1 1.003-1h4.994c.554 0 1.003.444 1.003 1 0 .552-.449 1-1.003 1h-4.994C11.449 12 11 11.556 11 11zm0 3c0-.552.444-1 1-1h3c.552 0 1 .444 1 1 0 .552-.444 1-1 1h-3c-.552 0-1-.444-1-1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriver);
export default __webpack_public_path__ + "static/media/driver.439f3907847b3f91ebe42acdc4568b57.svg";
export { ForwardRef as ReactComponent };